/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { heroBannerControllerCreateV1 } from '../fn/hero-banner/hero-banner-controller-create-v-1';
import { HeroBannerControllerCreateV1$Params } from '../fn/hero-banner/hero-banner-controller-create-v-1';
import { heroBannerControllerDeleteV1 } from '../fn/hero-banner/hero-banner-controller-delete-v-1';
import { HeroBannerControllerDeleteV1$Params } from '../fn/hero-banner/hero-banner-controller-delete-v-1';
import { heroBannerControllerFindByIdV1 } from '../fn/hero-banner/hero-banner-controller-find-by-id-v-1';
import { HeroBannerControllerFindByIdV1$Params } from '../fn/hero-banner/hero-banner-controller-find-by-id-v-1';
import { heroBannerControllerFindExposedV1 } from '../fn/hero-banner/hero-banner-controller-find-exposed-v-1';
import { HeroBannerControllerFindExposedV1$Params } from '../fn/hero-banner/hero-banner-controller-find-exposed-v-1';
import { heroBannerControllerSearchV1 } from '../fn/hero-banner/hero-banner-controller-search-v-1';
import { HeroBannerControllerSearchV1$Params } from '../fn/hero-banner/hero-banner-controller-search-v-1';
import { heroBannerControllerToggleExposedV1 } from '../fn/hero-banner/hero-banner-controller-toggle-exposed-v-1';
import { HeroBannerControllerToggleExposedV1$Params } from '../fn/hero-banner/hero-banner-controller-toggle-exposed-v-1';
import { heroBannerControllerUpdateV1 } from '../fn/hero-banner/hero-banner-controller-update-v-1';
import { HeroBannerControllerUpdateV1$Params } from '../fn/hero-banner/hero-banner-controller-update-v-1';
import { HeroBannerDto } from '../models/hero-banner-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class HeroBannerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `heroBannerControllerSearchV1()` */
  static readonly HeroBannerControllerSearchV1Path = '/api/v1/hero-banner/search';

  /**
   * HeroBanner 검색 (Admin용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heroBannerControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerSearchV1$Response(params?: HeroBannerControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<HeroBannerDto>;
}>> {
    return heroBannerControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * HeroBanner 검색 (Admin용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `heroBannerControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerSearchV1(params?: HeroBannerControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<HeroBannerDto>;
}> {
    return this.heroBannerControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<HeroBannerDto>;
}>): OffsetPaginationDto & {
'items'?: Array<HeroBannerDto>;
} => r.body)
    );
  }

  /** Path part for operation `heroBannerControllerFindExposedV1()` */
  static readonly HeroBannerControllerFindExposedV1Path = '/api/v1/hero-banner';

  /**
   * 노출 중인 HeroBanner 조회 (Client용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heroBannerControllerFindExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerFindExposedV1$Response(params?: HeroBannerControllerFindExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
    return heroBannerControllerFindExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 노출 중인 HeroBanner 조회 (Client용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `heroBannerControllerFindExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerFindExposedV1(params?: HeroBannerControllerFindExposedV1$Params, context?: HttpContext): Observable<HeroBannerDto> {
    return this.heroBannerControllerFindExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeroBannerDto>): HeroBannerDto => r.body)
    );
  }

  /** Path part for operation `heroBannerControllerCreateV1()` */
  static readonly HeroBannerControllerCreateV1Path = '/api/v1/hero-banner';

  /**
   * HeroBanner 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heroBannerControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heroBannerControllerCreateV1$Response(params: HeroBannerControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
    return heroBannerControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * HeroBanner 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `heroBannerControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heroBannerControllerCreateV1(params: HeroBannerControllerCreateV1$Params, context?: HttpContext): Observable<HeroBannerDto> {
    return this.heroBannerControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeroBannerDto>): HeroBannerDto => r.body)
    );
  }

  /** Path part for operation `heroBannerControllerFindByIdV1()` */
  static readonly HeroBannerControllerFindByIdV1Path = '/api/v1/hero-banner/{id}';

  /**
   * HeroBanner id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heroBannerControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerFindByIdV1$Response(params: HeroBannerControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
    return heroBannerControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * HeroBanner id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `heroBannerControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerFindByIdV1(params: HeroBannerControllerFindByIdV1$Params, context?: HttpContext): Observable<HeroBannerDto> {
    return this.heroBannerControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeroBannerDto>): HeroBannerDto => r.body)
    );
  }

  /** Path part for operation `heroBannerControllerDeleteV1()` */
  static readonly HeroBannerControllerDeleteV1Path = '/api/v1/hero-banner/{id}';

  /**
   * HeroBanner 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heroBannerControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerDeleteV1$Response(params: HeroBannerControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return heroBannerControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * HeroBanner 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `heroBannerControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerDeleteV1(params: HeroBannerControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.heroBannerControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `heroBannerControllerUpdateV1()` */
  static readonly HeroBannerControllerUpdateV1Path = '/api/v1/hero-banner/{id}';

  /**
   * HeroBanner 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heroBannerControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heroBannerControllerUpdateV1$Response(params: HeroBannerControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
    return heroBannerControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * HeroBanner 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `heroBannerControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heroBannerControllerUpdateV1(params: HeroBannerControllerUpdateV1$Params, context?: HttpContext): Observable<HeroBannerDto> {
    return this.heroBannerControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeroBannerDto>): HeroBannerDto => r.body)
    );
  }

  /** Path part for operation `heroBannerControllerToggleExposedV1()` */
  static readonly HeroBannerControllerToggleExposedV1Path = '/api/v1/hero-banner/{id}/toggle-exposed';

  /**
   * HeroBanner 노출 여부 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heroBannerControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerToggleExposedV1$Response(params: HeroBannerControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
    return heroBannerControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * HeroBanner 노출 여부 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `heroBannerControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heroBannerControllerToggleExposedV1(params: HeroBannerControllerToggleExposedV1$Params, context?: HttpContext): Observable<HeroBannerDto> {
    return this.heroBannerControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeroBannerDto>): HeroBannerDto => r.body)
    );
  }

}
